export const AVAILABLE_INTEGRATIONS = ["gmail", "outlook"] as const;
